(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fit-tea-social-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fit-social-video-slider')) {
    class FitSocialVideoSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('.fsv__viewport');
        this.cards = Array.from(this.querySelectorAll('.fsv__card'));
        this.previousButton = this.querySelector('.fsv__arrow--previous');
        this.nextButton = this.querySelector('.fsv__arrow--next');
        this.status = this.querySelector('.fsv__status');
        if (!this.viewport || !this.cards.length) return;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => this.handleKeyboard(event));
        this.addEventListener('click', (event) => this.handleLoad(event));
        this.querySelectorAll('video').forEach((video) => {
          const label = video.closest('.fsv__media')?.dataset.videoLabel;
          if (label) video.setAttribute('aria-label', label);
          video.addEventListener('play', () => this.pauseOtherVideos(video));
        });
        this.updateControls();
      }

      nearestIndex() {
        const position = this.viewport.scrollLeft;
        return this.cards.reduce((best, card, index) => {
          const bestDistance = Math.abs(this.cards[best].offsetLeft - position);
          const distance = Math.abs(card.offsetLeft - position);
          return distance < bestDistance ? index : best;
        }, 0);
      }

      move(direction) {
        const current = this.nearestIndex();
        const target = Math.max(0, Math.min(this.cards.length - 1, current + direction));
        this.cards[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.announce(target);
      }

      handleKeyboard(event) {
        if (event.target !== this.viewport) return;
        let target;
        if (event.key === 'ArrowRight') target = Math.min(this.cards.length - 1, this.nearestIndex() + 1);
        if (event.key === 'ArrowLeft') target = Math.max(0, this.nearestIndex() - 1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.cards.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        this.cards[target].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.announce(target);
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.updateControls();
          this.frame = null;
        });
      }

      updateControls() {
        const index = this.nearestIndex();
        if (this.previousButton) this.previousButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.cards.length - 1;
      }

      announce(index) {
        if (!this.status) return;
        this.status.textContent = this.cards[index].getAttribute('aria-label') || '';
      }

      pauseOtherVideos(activeVideo) {
        this.querySelectorAll('video').forEach((video) => {
          if (video !== activeVideo) video.pause();
        });
      }

      handleLoad(event) {
        const button = event.target.closest('.fsv__load');
        if (!button || !this.contains(button)) return;
        const media = button.closest('.fsv__media');
        const error = media.querySelector('.fsv__error');
        const embed = this.embedDetails(button.dataset.provider, button.dataset.url);
        if (!embed) {
          error.textContent = this.dataset.invalidMessage;
          error.hidden = false;
          return;
        }

        media.classList.add('is-loading');
        media.setAttribute('aria-busy', 'true');
        error.hidden = true;
        const iframe = document.createElement('iframe');
        iframe.className = 'fsv__embed';
        iframe.src = embed.src;
        iframe.title = button.dataset.title || 'Social video';
        iframe.loading = 'lazy';
        iframe.allow = embed.allow;
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.addEventListener('load', () => {
          media.classList.remove('is-loading');
          media.removeAttribute('aria-busy');
        }, { once: true });
        media.appendChild(iframe);
        button.hidden = true;
        media.querySelector('.fsv__cover, .fsv__cover-placeholder')?.setAttribute('hidden', '');
      }

      embedDetails(provider, value) {
        try {
          const url = new URL(value);
          const host = url.hostname.toLowerCase().replace(/^www\./, '');
          if (provider === 'youtube') {
            let id = url.searchParams.get('v');
            if (host === 'youtu.be') id = url.pathname.split('/').filter(Boolean)[0];
            if (!id && (host === 'youtube.com' || host === 'm.youtube.com')) {
              const parts = url.pathname.split('/').filter(Boolean);
              if (['shorts', 'embed', 'live'].includes(parts[0])) id = parts[1];
            }
            if (!id || !/^[\w-]{6,}$/.test(id)) return null;
            return {
              src: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`,
              allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            };
          }
          if (provider === 'tiktok') {
            const match = url.pathname.match(/\/video\/(\d+)/);
            if (!match || !host.endsWith('tiktok.com')) return null;
            return {
              src: `https://www.tiktok.com/player/v1/${match[1]}?autoplay=1&controls=1`,
              allow: 'autoplay; encrypted-media; picture-in-picture'
            };
          }
          if (provider === 'instagram') {
            const match = url.pathname.match(/\/(p|reel|tv)\/([^/?#]+)/);
            if (!match || !host.endsWith('instagram.com')) return null;
            return {
              src: `https://www.instagram.com/${match[1]}/${match[2]}/embed/captioned/`,
              allow: 'autoplay; encrypted-media; picture-in-picture'
            };
          }
          return null;
        } catch (error) {
          return null;
        }
      }
    }

    customElements.define('fit-social-video-slider', FitSocialVideoSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
